export default __webpack_public_path__ + "static/media/chairlift.0bb280cc.png";